import { Status } from '@bitcine/cinesend-theme/dist'

const DataCard = ({ children, title, className, isLoading, error }) => {
  const cssClassName = [...new Set(`border bg-primary-100 rounded p-4 ${className ?? ''}`.split(' '))].join(' ')

  return (
    <Status pending={isLoading} error={error}>
      <div className={cssClassName}>
        {title && <p className='font-semibold mb-2'>{title}</p>}
        {children}
      </div>
    </Status>
  )
}

export default DataCard
